// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestDirectorySearch-cls1_XLp","cls2":"ResearchInterestDirectorySearch-cls2_ycM ResearchInterestDirectorySearch-cls1_XLp"};